

import { Map, Record } from 'immutable';

export interface ImportState extends Map<string, any> {

  uploadFile: any;
  uploadFileLoading: any;
  uploadFileLoaded: any;
  uploadFileFailed: any;


}

export const ImportStateRecord = Record({

  uploadFile: {},
  uploadFileLoading: false,
  uploadFileLoaded: false,
  uploadFileFailed: false,

});
